module.exports = __webpack_public_path__ + "static/media/search.e103ff7d.svg";